import { render } from "./ResultWidget.vue?vue&type=template&id=0666d6e6"
import script from "./ResultWidget.vue?vue&type=script&lang=js"
export * from "./ResultWidget.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__